/*
  Feito por André e Amauri
  09/08/2018
*/

import React from 'react';
import { connect } from 'react-redux';
import {modificaToken, modificaNome} from '../actions/LoginActions';

export default (ComposedComponent) => {
  class Authenticate extends React.Component {
    constructor(props){
      super(props);
      if (props.token === '') {
        const localToken = localStorage.getItem('token');
        const localName = localStorage.getItem('nome');
        const nvl = localStorage.getItem('nvl');
        if (!localToken || !localName || !nvl) {
          props.history.push('/');
          return;
        }
        props.modificaToken(localToken);
        props.modificaNome(localName)
      }
    }

    render() {
      return (
        <ComposedComponent {...this.props} />
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      token: state.LoginReducer.token,
    };
  }

  return connect(mapStateToProps, { modificaToken, modificaNome })(Authenticate);
}



// WEBPACK FOOTER //
// ./src/helpers/RequireAuth.js